import script from "./StatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatCard.vue?vue&type=script&setup=true&lang=js"

import "./StatCard.vue?vue&type=style&index=0&id=63c3788e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c3788e"]])

export default __exports__